/**
 * Climate API Configuration Interface
 */
export interface ClimateApiConfig {
  baseUrl: string;
  timeout: number;
  retryAttempts: number;
  retryDelay: number;
  enableLogging: boolean;
}

/**
 * Climate API Error Types
 */
export enum ClimateApiErrorType {
  NETWORK_ERROR = 'NETWORK_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR'
}

/**
 * Standard API Response wrapper
 */
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  error?: {
    message: string;
    details?: unknown;
  };
}

/**
 * Request options for climate API calls
 */
export interface ClimateApiRequestOptions extends RequestInit {
  timeout?: number;
  retries?: number;
}

/**
 * Correlation ID for request tracking
 */
export interface RequestContext {
  correlationId: string;
  timestamp: number;
}

/**
 * Logging interface for API requests
 */
export interface ApiRequestLog {
  method: string;
  url: string;
  correlationId: string;
  timestamp: number;
  duration?: number;
  statusCode?: number;
  error?: string;
} 